<!--
@create date 2023-6-26
@desc M833.phomemo.com
-->
<template>
  <div class="guides-div-h831">
    <div class="topText">
      <h1>Download for Phomemo H832 Portable Printer</h1>
    </div>
    <!--   <hr style="color: rgba(51, 61, 71,0.3);width: 30%;margin-bottom: 50px;" v-show="!isMobile()" /> -->
    <div class="main-contain">
      <!--     phone -->
      <div class="item-margin" v-show="isMobile()">
        <div style="margin-bottom: 23px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://downloadapp.qu-in.life/MrIn-Phomemo/"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'H832_AppStore' });
              }
            "
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video controls webkit-playsinline="true" class="video">
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m08f_phone.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
      </div>
      <!--     windows -->
      <div class="item-margin">
        <div style="margin-bottom: 20px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%20Driver_WIN_EN.zip"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'H832_windowsDrivers' });
              }
            "
            >Driver for Windows</a
          >
        </div>
        <div class="video-contain">
          <video controls webkit-playsinline="true" class="video">
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <div class="item-margin">
        <div style="margin-bottom: 15px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%C2%A0Driver_Windows_ARM.zip"
            class="a-link"
            style="line-height: 26px; font-size: 16px"
            @click="
              () => {
                refreshRecord({ key: 'H832_windowsARMDrivers' });
              }
            "
            >Driver for Windows(ARM)</a
          >
        </div>
        <div class="video-contain">
          <video controls webkit-playsinline="true" class="video">
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!--     mac -->
      <div class="item-margin">
        <div style="margin-bottom: 14px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              margin-bottom: 20px;
            "
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%20Driver_MAC_EN.zip"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'H832_macDrivers' });
              }
            "
            >Driver for Mac</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 88%"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_mac_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!-- Linux -->
      <div class="item-margin">
        <div style="margin-bottom: 14px">
          <img
            src="https://pages.phomemo.com/resources/linuxIcon.png"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              height: 110px;
            "
          />
          <a
            href="https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Linux.zip"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'H832_linuxDrivers' });
              }
            "
            >Driver for Linux</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/pm246s_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!--     phone -->
      <div class="item-margin" v-show="!isMobile()">
        <div style="margin-bottom: 23px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            href="https://downloadapp.qu-in.life/MrIn-Phomemo/"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'H832_AppStore' });
              }
            "
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video controls webkit-playsinline="true" class="video">
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m08f_phone.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <!-- Driver for Chrome -->
      <div class="item-margin" style="min-height: 344px">
        <div style="margin-bottom: 24px">
          <img
            src="https://pages.phomemo.com/resources/chromeIcon.png"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              margin-bottom: 21px;
            "
          />
          <a
            href="https://oss.qu-in.ltd/OfficialWebsite/Phomemo/QY_Printer%C2%A0Driver_ChromeOS.zip"
            class="a-link"
            @click="
              () => {
                refreshRecord({ key: 'H832_chromeOSDrivers' });
              }
            "
            >Driver for ChromeOS</a
          ><br />
        </div>
        <div class="video-contain">
          <!-- <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
          >
            <source
              src=""
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video> -->
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
    </div>
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 54%; margin-bottom: 40px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-bottom: 40px"
      v-show="isMobile()"
    />
    <div class="customService" style="margin-top: 10px">
      <h1>Quick Start Guide</h1>
      <div>
        <a
          style="color: #1fc3ff; text-decoration: auto"
          href="https://oss.qu-in.top/printerFiles/phomemo/H832QuickGuide.pdf"
          target="_blank"
          @click="
            () => {
              refreshRecord({ key: 'H832_quickStartGuide' });
            }
          "
          >Click Here for A Quick Start Guide</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { refreshRecord, sensorsRecord } from "@/util.js";
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "H832",
  props: {},
  data() {
    return {
      activeQuestion2: {},
      isMobile,
      refreshRecord,
      sensorsRecord,
    };
  },
  mounted() {
    sensorsRecord({ key: "H832_view" }, 1);
    sensorsRecord({ key: "H832_WebStay" }, 3);
  },
  methods: {
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./H831.less" />



// WEBPACK FOOTER //
// src/view/guides/H832.vue